export const BOT_COLOR_MAP: Record<string, string> = {
  // Platform-level
  ChatGPT: '#10a37f',
  OpenAI: '#10a37f',
  Claude: '#d97706',
  Anthropic: '#d97706',
  Perplexity: '#6366f1',
  Google: '#4285f4',
  Gemini: '#4285f4',
  Meta: '#0866ff',
  Amazon: '#ff9900',
  ByteDance: '#111111',
  Apple: '#555555',
  'Common Crawl': '#9ca3af',
  'You.com': '#7e6dff',
  DuckDuckGo: '#de5833',
  Microsoft: '#0078d4',
  xAI: '#1d9bf0',
  DeepSeek: '#7c3aed',
  Unknown: 'var(--grey-ux-400)',

  // OpenAI / ChatGPT bots
  GPTBot: '#10a37f',
  'ChatGPT-User': '#34c799',
  'ChatGPT-Search': '#0d8a6a',
  'OAI-SearchBot': '#0a6c54',

  // Anthropic / Claude bots
  ClaudeBot: '#d97706',
  'Claude-User': '#f59e0b',
  'anthropic-ai': '#b45309',

  // Perplexity bots
  PerplexityBot: '#6366f1',
  'Perplexity-User': '#818cf8',

  // Google bots
  Googlebot: '#4285f4',
  'Google-Extended': '#1a73e8',
  'Gemini-Deep-Research': '#669df6',
  GoogleOther: '#aecbfa',

  // Other vendor bots
  Bytespider: '#000000',
  Amazonbot: '#ff9900',
  'Meta-ExternalAgent': '#0866ff',
  CCBot: '#6b7280',
  'Applebot-Extended': '#555555',
  Ai2Bot: '#9ca3af',
  'cohere-ai': '#39594d',
  Bingbot: '#008373',

  // Bot types (for byBotType breakdown chart)
  Training: '#d97706',
  Search: '#4285f4',
  'User query': '#6366f1',
  Other: '#9ca3af',
};

export const DEFAULT_BOT_COLOR = 'var(--grey-ux-500)';

export const getBotColor = (name: string): string => {
  return BOT_COLOR_MAP[name] ?? DEFAULT_BOT_COLOR;
};

/**
 * Maps the raw `platform` value stored in `bots` to a user-facing display name.
 * The DB column carries the vendor company name (e.g. `'OpenAI'`, `'Anthropic'`)
 * but the dashboard speaks in product names (`'ChatGPT'`, `'Claude'`). Anything not
 * in the map passes through unchanged.
 *
 * MUST be applied consistently in every UI surface that aggregates by platform —
 * platform cards, timeseries chart series, and breakdown tables — otherwise the
 * same vendor's data gets split between two different keys and totals don't sum.
 */
export const PLATFORM_DISPLAY_NAME_MAP: Record<string, string> = {
  OpenAI: 'ChatGPT',
  Anthropic: 'Claude',
};

export const getPlatformDisplayName = (platform: string): string =>
  PLATFORM_DISPLAY_NAME_MAP[platform] ?? platform;
